export default __webpack_public_path__ + "static/application@2x-b712223c24ed26c76ba3ca3758c74de2.png";